<template>
    <b-tooltip :active="!disableTooltip" :label="label" animated type="is-white"
        ><div class="ls-service-status-indicator" :style="{ background: color }"></div
    ></b-tooltip>
</template>

<script>
import VueTypes from 'vue-types';
import { lsColors } from '@/constants';

export default {
    name: 'LsServiceStatusIndicator',
    props: {
        service: VueTypes.shape({
            status: VueTypes.string.isRequired,
        }).isRequired.loose,
        disableTooltip: VueTypes.bool.def(false),
    },
    computed: {
        statuses() {
            return {
                active: { color: lsColors['success'], verb: 'is' },
                approved: { color: lsColors['success'], verb: 'was' },
                authorized: { color: lsColors['success'], verb: 'was' },
                cancelled: { color: lsColors['danger'], verb: 'was' },
                ended: { color: lsColors['gray-primary'], verb: 'has' },
                expired: { color: lsColors['gray-primary'], verb: 'has' },
                paused: { color: lsColors['info-hover'], verb: 'is' },
                pending: { color: lsColors['gray-primary'], verb: 'is' },
                ready: { color: lsColors['gray-primary'], verb: 'is' },
                rejected: { color: lsColors['danger'], verb: 'was' },
            };
        },
        color() {
            return this.statuses[this.service.status]['color'];
        },
        label() {
            return `This service ${this.statuses[this.service.status]['verb']} ${
                this.service.status
            }`;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-service-status-indicator {
    border-radius: 6px;
    width: 12px;
    height: 12px;
}
</style>
